module.exports = __webpack_public_path__ + "img/dpsy-icon-zhiy.9a47e547.png";